<template lang="pug">
  .product-wrapper
    .name
      span.name {{ product.description }}
      span.sku.font-weight-bold {{ product.sku }}
      span.no-return-messsage.font-size-xs(v-if="product.qtyReturnable === 0") {{ __('Item unable to be returned') }}
    .options(v-if="product.children.length")
      div {{ __('Includes') }}:
      span(v-for="child in product.children" :key="child.sku")
        | {{ child.description }} &nbsp;
        span.font-weight-bold x {{ child.qtyOrdered }}
        br
    .details.font-weight-bold.font-size-xxs(
      v-if="detailedInfo && returnProduct.returnType === 'exchange'"
    ) {{ __(getReturnReasonLabel()) }} - {{ __('Exchange for') }}: {{ returnProduct.returnComment }}
</template>

<script setup lang="ts">
import { type PropType } from 'vue'
import { ExchangeReasons } from '../helpers'
import type { OrderedProduct, ReturningProduct } from '../types'

const props = defineProps({
  product       : { type: Object as PropType<OrderedProduct>, required: true },
  returnProduct : { type: Object as PropType<ReturningProduct | null>, default: null },
  detailedInfo  : { type: Boolean, default: false },
})

function getReturnReasonLabel() {
  const reasonKey = props.returnProduct?.returnReason as keyof typeof ExchangeReasons
  
  return reasonKey ? ExchangeReasons[reasonKey] : ''
}
</script>

<style lang="scss" scoped>
.product-wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.sku {
  margin-left: $space-xxs;
  color: $color-black-light;
}
.name {
  font-size: $size-xs;
  line-height: $line-height-m;
  color: $color-black;
}
.options {
  margin-top: $space-xxs;
  color: $color-black-light;
  font-size: $size-xxs;
  line-height: 18px;
}
.details {
  margin-top: $space-xxs;
}
.no-return-messsage {
  margin-left: $space-s;
  font-style: italic;
}
</style>
